<template>
    <form-wrapper class="intake-meds" @submit="handleFormSubmission(data)">
        <intake-form-section :title="$t('forms.intake.medications_allergies.sections.current_medications')">
            <form-row>
                <form-cell>
                    <tabs-field
                        :options="triStateOptions"
                        :formData="data"
                        valuePath="currentMedications"
                        size="small"
                        @change="change($event)"
                    ></tabs-field>
                </form-cell>
            </form-row>
        </intake-form-section>

        <intake-form-section :title="$t('forms.intake.medications_allergies.sections.allergies')">
            <form-row>
                <form-cell>
                    <radio-field
                        :options="allergyOptions"
                        :formData="data"
                        valuePath="allergies"
                        direction="column"
                        @change="change($event)"
                    ></radio-field>
                </form-cell>
            </form-row>
        </intake-form-section>

        <template #footer>
            <common-buttons>
                <common-button
                    :label="$t('common.microcopy.back')"
                    type="secondary"
                    size="large"
                    :isSubmittable="false"
                    @click="goBack"
                ></common-button>
                <common-button
                    :label="$t('common.microcopy.next')"
                    type="primary"
                    size="large"
                    :isProcessing="isSending"
                ></common-button>
            </common-buttons>
        </template>
    </form-wrapper>
</template>

<script>
    import FormMixin from 'mixins/FormMixin'
    import IntakeFormSection from 'components/forms/intake/IntakeFormSection'

    const ALLERGY_STATUSES = ['no_known_drug_allergies', 'yes', 'unknown']

    export default {
        mixins: [FormMixin],

        components: {
            IntakeFormSection,
        },

        props: {
            initialData: { type: Object, default: undefined },
        },

        data() {
            return {
                data: {
                    currentMedications: undefined,
                    allergies: undefined,
                    ...(this.initialData || {}),
                },
            }
        },

        computed: {
            triStateOptions() {
                return ['yes', 'no', 'unsure'].map((value) => ({
                    label: this.$t(`forms.intake.what_happened.fields.tri_state.options.${value}`),
                    value,
                }))
            },

            allergyOptions() {
                return ALLERGY_STATUSES.map((value) => ({
                    label: this.$t(`forms.intake.medications_allergies.fields.allergies.options.${value}`),
                    value,
                }))
            },
        },

        methods: {
            goBack() {
                this.emitEvent({ name: 'back', payload: this.data })
            },

            handleFormSubmission(data) {
                this.isSending = true
                this.emitSent(data)
                this.isSending = false
            },
        },
    }
</script>
